import { baseUrl, studioBaseUrl } from '../../utils/urls'
import type { NavItem } from '../use-nav-items'
import type { TranslateFn } from './types'

export function buildStudioMenuItem(t: TranslateFn, langSegment: string): NavItem {
  return {
    id: 'studio',
    name: t('navigation.studio.name'),
    link: `${studioBaseUrl}/`,
    subMenuItems: [
      {
        id: 'ai_tools',
        name: t('navigation.studio.ai_tools.name'),
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.studio.ai_tools.vectorize_any_image'),
            link: `${studioBaseUrl}/vectorizer`,
          },
          {
            name: t('navigation.studio.ai_tools.upscale_image'),
            link: `${studioBaseUrl}/image-upscaler`,
          },
          {
            name: t('navigation.studio.ai_tools.remove_background'),
            link: `${studioBaseUrl}/background-remover`,
          },
          {
            name: t('navigation.studio.ai_tools.ai_image_generator'),
            link: `${studioBaseUrl}/flow`,
          },
          {
            name: t('navigation.studio.ai_tools.ai_image_editor'),
            link: `${studioBaseUrl}/ai-image-editor`,
          },
          {
            name: t('navigation.studio.ai_tools.ai_quote_generator'),
            link: `${studioBaseUrl}/ai-quote-generator`,
          },
          {
            name: t('navigation.studio.ai_tools.ai_logo_generator'),
            link: `${studioBaseUrl}/logo-creator`,
          },
          {
            name: t('navigation.studio.ai_tools.ai_design_reviewer'),
            link: `${studioBaseUrl}/ai-design-reviewer`,
          },
          {
            name: t('navigation.studio.ai_tools.ai_font_generator'),
            link: `${studioBaseUrl}/font-generator`,
          },
          {
            name: t('navigation.studio.ai_tools.file_converter'),
            link: `${studioBaseUrl}/file-converter`,
          },
          {
            name: t('navigation.studio.ai_tools.image_compressor'),
            link: `${studioBaseUrl}/image-compressor`,
          },
          {
            name: t('navigation.studio.ai_tools.large_file_transfer'),
            link: `${studioBaseUrl}/transfer`,
          },
          {
            name: t('navigation.studio.ai_tools.studio_designer'),
            link: `${studioBaseUrl}/studio/create`,
          },
          {
            name: t('navigation.studio.explore'),
            link: `${baseUrl}${langSegment}/studio/`,
            isFootOption: true,
          },
        ],
      },
      {
        id: 'create',
        name: t('navigation.studio.create.design'),
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.studio.create.design'),
            link: `${studioBaseUrl}/studio/create?navigation-bar=templates`,
          },
          {
            name: t('navigation.studio.create.browse_templates'),
            link: '/studio/templates/',
          },
          {
            name: t('navigation.studio.create.generate_png_with_ai'),
            link: `${studioBaseUrl}/studio/create/?navigation-bar=spark-ai&tab=crystalline`,
          },
          {
            name: t('navigation.studio.create.browse_graphics'),
            link: `${studioBaseUrl}/studio/create/?navigation-bar=graphics`,
          },
          {
            name: t('navigation.studio.create.browse_photos'),
            link: `${studioBaseUrl}/studio/create/?navigation-bar=photos`,
          },
          {
            name: t('navigation.studio.create.browse_backgrounds'),
            link: `${studioBaseUrl}/studio/create/?navigation-bar=background`,
          },
          {
            name: t('navigation.studio.create.browse_patterns'),
            link: `${studioBaseUrl}/studio/create/?navigation-bar=patterns`,
          },
          {
            name: t('navigation.studio.create.draw'),
            link: `${studioBaseUrl}/studio/create/?navigation-bar=draw`,
          },
          {
            name: t('navigation.studio.create.more_tools'),
            link: `${studioBaseUrl}/`,
          },
          {
            name: t('navigation.studio.explore'),
            link: `${baseUrl}${langSegment}/studio/`,
            isFootOption: true,
          },
        ],
      },
      {
        id: 'templates',
        name: t('navigation.studio.templates.name'),
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.studio.templates.discover'),
            link: `${baseUrl}${langSegment}/studio/templates/`,
          },
          {
            name: t('navigation.studio.templates.easter'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=easter`,
          },
          {
            name: t('navigation.studio.templates.mothers_day'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=mothers+day`,
          },
          {
            name: t('navigation.studio.templates.wedding_invites'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=wedding`,
          },
          {
            name: t('navigation.studio.templates.birthday_cards'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=birthday`,
          },
          {
            name: t('navigation.studio.templates.bridal_shower'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=bridal+shower`,
          },
          {
            name: t('navigation.studio.templates.save_the_date'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=save+the+date`,
          },
          {
            name: t('navigation.studio.templates.in_loving_memory'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=loving+memory`,
          },
          {
            name: t('navigation.studio.templates.ticket'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=ticket`,
          },
          {
            name: t('navigation.studio.templates.graduation'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=Graduation`,
          },
          {
            name: t('navigation.studio.templates.halloween_party'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=halloween`,
          },
          {
            name: t('navigation.studio.templates.business_templates'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=business`,
          },
          {
            name: t('navigation.studio.templates.church'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=Church`,
          },
          {
            name: t('navigation.studio.templates.sweet_sixteen'),
            link: `${baseUrl}${langSegment}/studio/templates/?query=Sweet+Sixteen`,
          },
          {
            name: t('navigation.studio.templates.explore'),
            link: `${baseUrl}${langSegment}/studio/templates/`,
            isFootOption: true,
          },
        ],
      },
      {
        id: 'other_tools',
        name: t('navigation.studio.other_tools.name'),
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.studio.other_tools.vectorize_designs'),
            link: `${studioBaseUrl}/vectorizer`,
          },
          {
            name: t('navigation.studio.other_tools.send_large_files'),
            link: `${studioBaseUrl}/transfer`,
          },
          {
            name: t('navigation.studio.other_tools.remove_background'),
            link: `${studioBaseUrl}/background-remover`,
          },
          {
            name: t('navigation.studio.other_tools.shapecloud'),
            link: `${baseUrl}/shapecloud/`,
          },
          {
            name: t('navigation.studio.other_tools.webfont_generator'),
            link: `${baseUrl}/webfont-generator/`,
          },
          {
            name: t('navigation.studio.other_tools.text_generators'),
            link: `${baseUrl}/tools/ai-font-generators/`,
          },
          {
            name: t('navigation.studio.explore'),
            link: `${baseUrl}${langSegment}/studio/`,
            isFootOption: true,
          },
        ],
      },
      {
        id: 'features',
        name: t('navigation.studio.features.name'),
        wrapItems: true,
        trending: {},
        subMenuItems: [
          {
            name: t('navigation.studio.features.background_remover'),
            link: `${baseUrl}${langSegment}/studio/features/background-remover/`,
          },
          {
            name: t('navigation.studio.features.background_changer'),
            link: `${baseUrl}${langSegment}/background-remover/lp/background-changer/`,
          },
          {
            name: t('navigation.studio.features.png_to_svg'),
            link: `${baseUrl}${langSegment}/studio/features/png-to-svg-converter/`,
          },
          {
            name: t('navigation.studio.features.mirror_image'),
            link: `${baseUrl}${langSegment}/studio/features/mirror-image/`,
          },
          {
            name: t('navigation.studio.features.rotate_image'),
            link: `${baseUrl}${langSegment}/studio/features/rotate-image/`,
          },
          {
            name: t('navigation.studio.features.crop_image'),
            link: `${baseUrl}${langSegment}/studio/features/crop-image/`,
          },
          {
            name: t('navigation.studio.features.add_text_on_image'),
            link: `${baseUrl}${langSegment}/studio/features/add-text-on-image/`,
          },
          {
            name: t('navigation.studio.features.change_photo_background'),
            link: `${baseUrl}${langSegment}/studio/features/change-photo-background-color/`,
          },
          {
            name: t('navigation.studio.features.erase_background_free'),
            link: `${baseUrl}${langSegment}/background-remover/lp/erase-background-free`,
          },
          {
            name: t('navigation.studio.features.circle_crop'),
            link: `${baseUrl}${langSegment}/studio/features/circle-crop/`,
          },
          {
            name: t('navigation.studio.features.overlay_images'),
            link: `${baseUrl}${langSegment}/studio/features/overlay-images/`,
          },
          {
            name: t('navigation.studio.features.ai_inpainting_tool'),
            link: `${baseUrl}${langSegment}/studio/features/ai-inpainting-tool/`,
          },
          {
            name: t('navigation.studio.features.resize_icon'),
            link: `${baseUrl}${langSegment}/studio/features/resize-icon/`,
          },
          {
            name: t('navigation.studio.features.watermark_to_photos'),
            link: `${baseUrl}${langSegment}/studio/features/watermark-to-photos/`,
          },
          {
            name: t('navigation.studio.features.view_all'),
            link: `${baseUrl}${langSegment}/studio/features/`,
            isFootOption: true,
          },
        ],
      },
      {
        id: 'start_designing',
        name: t('navigation.studio.start_designing'),
        link: `${studioBaseUrl}/studio/create?navigation-bar=templates`,
        isFootOption: true,
      },
    ],
  }
}
